// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"33c8e05b","453":"ef5c755d","455":"77d9a68e","977":"9533bb0a"}[chunkId] + ".chunk.js";
};